function relativeUrl(relative: string): URL {
    return new URL(`/api/v1/public${relative}`, window.location.origin);
}

export const WidgetApiConstants = {
    getRestaurantConfiguration(restaurantId: string): URL {
        return relativeUrl(`/restaurants/${restaurantId}`);
    },
    getRestaurantPublicMenu(restaurantId: string): URL {
        return relativeUrl(`/restaurants/${restaurantId}/menu`);
    },

    getRestaurantAvailableAreaTimes(
        restaurantId: string,
        participants: number,
        reservationDateTime: string,
        shiftId: string,
        areaId: string,
        expectedOccupancyTime?: number,
    ): URL {
        const url = relativeUrl(`/restaurants/${restaurantId}/slots`);
        const queryParams = new URLSearchParams();
        queryParams.append('participants', `${participants}`);
        queryParams.append('reservationDateTime', reservationDateTime);
        queryParams.append('shiftId', shiftId);
        queryParams.append('areaId', areaId);
        if (expectedOccupancyTime) {
            queryParams.append('expectedOccupancyTime', `${expectedOccupancyTime}`);
        }
        url.search = queryParams.toString();
        return url;
    },

    saveReservation(restaurantId: string): URL {
        return relativeUrl(`/restaurants/${restaurantId}/reservations`);
    },

    getShifts(restaurantId: string, date: string, participants: number): URL {
        const url = relativeUrl(`/restaurants/${restaurantId}/shifts`);
        const queryParams = new URLSearchParams();
        queryParams.append('reservationDateTime', `${date}`);
        queryParams.append('participants', `${participants}`);
        url.search = queryParams.toString();
        return url;
    },

    getReservation(restaurantId: string, token: string): URL {
        return relativeUrl(`/restaurants/${restaurantId}/reservations/${token}`);
    },
};
